import { render, staticRenderFns } from "./TaskPointTeam.vue?vue&type=template&id=3e4bac0f&scoped=true"
import script from "./TaskPointTeam.vue?vue&type=script&lang=js"
export * from "./TaskPointTeam.vue?vue&type=script&lang=js"
import style0 from "./TaskPointTeam.vue?vue&type=style&index=0&id=3e4bac0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4bac0f",
  null
  
)

export default component.exports